import "./style.scss";
import "./yarl.scss";

import "yet-another-react-lightbox/plugins/thumbnails.css";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

window.addEventListener("load", () => {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById("album-root")
  );
});
